module.exports = __webpack_public_path__ + "static/img/icon-prize.8482bb96.svg";